import React from 'react';

export default function Preview({ text, scrapedAt }) {
  const formattedDate = scrapedAt
    ? new Date(scrapedAt).toLocaleString('sl-SI')
    : '';

  return (
    <div className="preview-card">
      <div className="preview-header">
        <h2>Message Preview</h2>
        {formattedDate && <span className="meta">Data from: {formattedDate}</span>}
      </div>
      <div className="preview-body">{text || 'No preview available.'}</div>
    </div>
  );
}
